import { render, staticRenderFns } from "./dj-button.vue?vue&type=template&id=ddb2453c&scoped=true"
import script from "./dj-button.vue?vue&type=script&lang=js"
export * from "./dj-button.vue?vue&type=script&lang=js"
import style0 from "./dj-button.vue?vue&type=style&index=0&id=ddb2453c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb2453c",
  null
  
)

export default component.exports